import { Component, ElementRef, inject, input, model, OnInit, ViewChild } from '@angular/core';
import * as uuid from 'uuid';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgbAlert, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ButtonTypes } from '@core/enums/button-types';
import { NgForm } from '@angular/forms';
import { AlertTypes } from '@core/enums/alert-types';

export class AlertOptions {
  id?: string = uuid.v4();
  class?: string;
  title?: string;
  text?: string;
  type?: AlertTypes;
  show?: Boolean;

  constructor(args?: AlertOptions) {
    this.id = args?.id || uuid.v4();
    this.class = args?.class || 'btn';
    this.title = args?.title || '';
    this.text = args?.text;
    this.type = args?.type || AlertTypes.light;
    this.show = args?.show || false;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-alert',
  imports: [NgbAlert],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private elementRef = inject(ElementRef);
  protected translations = this.translate.instant('alert');

  options = model<AlertOptions>(new AlertOptions());

  ngOnInit() {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('alert');
    });
  }
}
